import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Simple "Back to Dashboard" link component
 * Add this to any Profit Map page that doesn't have navigation back to dashboard
 *
 * Usage: <BackToDashboard />
 * Or with custom module: <BackToDashboard module="business-model" />
 */
function BackToDashboard({ module = 'foundation', label = 'Back to Dashboard' }) {
  const navigate = useNavigate();

  const linkStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#6c757d',
    textDecoration: 'none',
    fontSize: '0.9rem',
    padding: '0.5rem 0',
    marginBottom: '1rem',
    cursor: 'pointer',
    transition: 'color 0.2s ease',
  };

  const arrowStyle = {
    marginRight: '0.5rem',
    fontSize: '1rem',
  };

  return (
    <div
      style={linkStyle}
      onClick={() => navigate(`/dashboard/${module}`)}
      onMouseEnter={(e) => e.currentTarget.style.color = '#495057'}
      onMouseLeave={(e) => e.currentTarget.style.color = '#6c757d'}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && navigate(`/dashboard/${module}`)}
    >
      <span style={arrowStyle}>←</span>
      {label}
    </div>
  );
}

export default BackToDashboard;
